import request from '@/utils/request'

// 获取栏目信息
// /api/cms/node/list?parentId=0&nodeType=content
// 获取文章信息
// /api/cms/article/list?nodeId=（单个栏目）&cnName=pNodeId=(获取子栏目)
// 获取文章详情
// /api/cms/article/{id}

// 
// 获取首页轮播
export const getBannerList=(query)=> {
  return request({
    url: '/api/sys/banner/list',
    method: 'get',
    params: query
  })
}

// 获取文章信息
export const getNodeList=(query)=> {
  return request({
    url: '/api/cms/node/list',
    method: 'get',
    params: query
  })
}


// 获取文章信息
export const getArticleList=(query)=> {
  return request({
    url: '/api/cms/article/list',
    method: 'get',
    params: query
  })
}
// 获取文章详情
export const getArticleDetail=(id)=> {
  return request({
    url: '/api/cms/article/'+id,
    method: 'get',
    // params: query
  })
}

// 查询公司列表
export const getCompanyList=(query)=> {
  return request({
    url: '/api/sys/company/list',
    method: 'get',
    params: query
  })
}
// 
// export const toUserNamelogin=(data)=> {
//   return request({
//     url: '/userNamelogin',
//     method: 'post',
//     data: data
//   })
// }